export default __webpack_public_path__ + "static/media/moz_icon.fd35e436.svg";